export default __webpack_public_path__ + "static/media/minus-square.1b394e07.svg";